const styles = theme => ({
  sectionTitle: {
    fontSize: '18px',
    marginBottom: theme.spacing(2),
  },
  buttonPlacement: {
    display: 'flex',
    alignItems: 'end',
  },
  checkboxPlacement: {
    display: 'flex',
    alignItems: 'end',
    marginBottom: '12px',
  },
  borderBottom: {
    borderBottom: '8px solid #EBEEF3',
  },
  containerPadding: {
    padding: '16px',
    border: `1px solid ${theme.palette.primary.borderColor}`,
    background: theme.palette.primary.white,
  },
  divider: {
    border: '1px solid #EBEEF3',
    margin: '8px 0',
  },
  strongText: {
    fontSize: '14px',
    fontWeight: '600',
    marginTop: '5px',
  },
  textAr: {
    fontFamily: '"madani", sans-serif',
    lineHeight: '18px',
  },
  ownerAvatarimg: {
    height: '64px',
    width: '64px',
    background: '#EBEEF3',
  },
  ownerDetailHolder: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
  },
  Border: {
    border: '1px solid #CED1D6',
    borderRadius: '0px',
    margin: '16px',
  },
  marginCls: {
    margin: '16px 0px',
  },
  readMoreCls: {
    fontWeight: '500',
    fontSize: '14px',
    color: '#130F26',
    lineHeight: '150%',
    textAlign: 'center',
    marginBottom: '8px',
  },
  readMoreLink: {
    width: 'fit-content',
    margin: '0 auto',
  },
  iconCls: {
    width: '12px',
    height: '6px',
    marginLeft: '6px',
  },
  titleWrapper: {
    background: 'transparent',
  },
  removeBtn: {
    transition: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textTransform: 'none',
    color: '#D2374F',
    fontSize: '14px',
    '& img': {
      marginRight: '4px',
      width: '14px',
    },
    '&:hover': {
      background: 'transparent',
    },
  },
  gridItem: {
    marginBottom: '16px',
  },
  hintText: {
    marginTop: '8px',
    display: 'flex',
    justifyContent: 'space-between',
    '& >p': {
      color: theme.palette.secondary.placeHolder,
      fontSize: '12px',
    },
  },
});
export default styles;
